import "./ContactRequestService.module.css";
import Header from "@/reusable_sections/Header";
import ContactMap from "./sections/ContactMap";
import RequestService from "./sections/RequestService";
import Footer from "@/reusable_sections/Footer";
export default function ContactRequestServicePage() {
  return <div>
      <Header />
      <ContactMap />
      <RequestService />
      <Footer />
    </div>;
}